import { AfterViewInit, Component, Input, OnInit } from '@angular/core';
import { CellClassRules, ColDef, ColumnApi, GridApi, GridOptions } from 'ag-grid-enterprise';
import * as moment from 'moment';
import { LazyLoadEvent, MessageService } from 'primeng/api';
import 'ag-grid-enterprise';
import { ReservationLedgerService } from '../reservation-ledger/reservation-ledger.service';

@Component({
    selector: 'app-reservation-ledger-list-summary',
    templateUrl: './reservation-ledger-list-summary.component.html',
    styleUrls: ['./reservation-ledger-list-summary.component.css'],
    standalone: false
})
export class ReservationLedgerListSummaryComponent implements OnInit {

	reservationLedgers: any = [];
	groupDefaultExpanded: any = 0;
	payToDetails: any;

	constructor(
		public messageService: MessageService,
		public reservationLedgerService: ReservationLedgerService,) { 
			this.payToDetails = reservationLedgerService.payToDetails;
		}

	gridApi: GridApi;
	columnApi: ColumnApi;

	autoGroupColumnDef = {
		headerName: 'Property',
		cellRendererParams: {
			suppressCount: true,
			// checkbox: true,
		}
	};

	defaultColDef: ColDef = {
		sortable: true,
		filter: true,
	};

	columnDefs: ColDef[] = [
		//Groups
		{ headerName: 'Property', field: 'propertyCode', rowGroup: true},
		// { headerName: 'Name', field: 'guestLastName', rowGroup: true, hide: true, sortable: true, sort:'asc'},
		{ headerName: 'Reservation #', field: 'reservationId', rowGroup: true, hide: true, sortable: true, valueGetter: (params) => {
			const reservationId = params?.data?.reservationId;
        	const guestLastName = params?.data?.guestLastName;
			// if (typeof listPrice === 'number' && typeof quantity === 'number') {
				return reservationId + ' ('+ guestLastName +')';
			// }
		}},
		
		//Columns
		{ headerName: 'In', field: 'checkInDateTime', cellRenderer: this.fullDateCellRendererUSD, },
		{ headerName: 'Out', field: 'checkOutDateTime', cellRenderer: this.fullDateCellRendererUSD, },
		{ headerName: 'Order #', field: 'orderId'},
		{ headerName: 'Reservation #', field: 'reservationId'},
		{ headerName: 'Order Product Id', field: 'orderProductId', hide: true, sortable: true, sort:'asc'},
		{ headerName: 'Title', field: 'title', cellRenderer: this.getReservationLedgerTitle},
		{ headerName: 'Pay From Order Prod', field: 'payFromOrderProductName', },
		{ headerName: 'Pay From', field: 'payFrom', cellRenderer: this.getPayFromName},
		{ headerName: 'Pay To', field: 'payTo', cellRenderer: this.getPayToName},
		{ headerName: 'Qty', field: 'quantity', },
		{ headerName: 'Price', field: 'listPrice',  valueFormatter: (params) => {
			if(params && params.value && typeof params.value === 'number')
			{
				const value = params.value;
				if (value < 0) {
					// If the value is negative, format as -$amount
					return `-$${Math.abs(value)}`;
				} else {
					// If the value is positive, format as $amount
					return `$${value}`;
				}
			}
		}},
		{ headerName: 'LPA%', field: 'listPriceAdjustmentPercent', },
		{ headerName: 'LPA$', field: 'listPriceAdjustmentAmount',  valueFormatter: (params) => {
			if(params && params.value && typeof params.value === 'number')
			{
				const value = params.value;
				if (value < 0) {
					// If the value is negative, format as -$amount
					return `-$${Math.abs(value)}`;
				} else {
					// If the value is positive, format as $amount
					return `$${value}`;
				}
			}
		}},
		{ headerName: 'Total', field: 'listPrice', valueGetter: (params) => {
			const listPrice = params?.data?.listPrice;
        	const quantity = params?.data?.quantity;
			if (typeof listPrice === 'number' && typeof quantity === 'number') {
				return listPrice * quantity;
			}
		}, valueFormatter: (params) => {
			if(params && params.value && typeof params.value === 'number')
			{
				const value = params.value;
				if (value < 0) {
					// If the value is negative, format as -$amount
					return `-$${Math.abs(value).toFixed(2)}`;
				} else {
					// If the value is positive, format as $amount
					return `$${value.toFixed(2)}`;
				}
			}
		}, aggFunc: 'sum'},
		// { headerName: 'Grand Total', field: 'listPrice', aggFunc: 'sum' },
	];

	gridOptions: GridOptions = {
		rowData: this.reservationLedgers,
		columnDefs: this.columnDefs,
		pagination: true,
		rowSelection: 'single',
		suppressAggFuncInHeader: true,

		// EVENTS
		// Add event handlers
		onRowClicked: event => console.log('A row was clicked'),
		onColumnResized: event => console.log('A column was resized'),
		onGridReady: event => console.log('The grid is now ready'),

		// CALLBACKS
		getRowHeight: (params) => 25,
	}


	// forms
	formLoading = false;

	getReservationsLedger(searchForm: any)
	{
		this.formLoading = true;
		let event: LazyLoadEvent = {};
		event['filters'] = {};
		let multiSortMeta = [];
		multiSortMeta.push({ field: 'reservationVO.checkInDateTime', order: 1 }, { field: 'reservationVO.reservationId', order: 1 }, { field: 'orderProductVO.orderProductId', order: 1 });
		event['multiSortMeta'] = multiSortMeta;
		if(searchForm.startDate)
		{
			let testCategoryFilter = { 'startDate': { 'value': searchForm.startDate, 'matchMode': 'in' } };
			Object.assign(event['filters'], testCategoryFilter);
		}
		if(searchForm.endDate)
		{
			let testCategoryFilter = { 'endDate': { 'value': searchForm.endDate, 'matchMode': 'in' } };
			Object.assign(event['filters'], testCategoryFilter);
		}
		try {
			this.reservationLedgerService.findSummaryByFilter(
				0, event.rows,
				event.sortField,
				event.sortOrder,
				event.multiSortMeta,
				event.globalFilter,
				event.filters).pipe().subscribe(
					(res: any) => {
						this.formLoading = false;
						this.reservationLedgers = res.data.reservationLedgers;
					},
					(err: any) => {
						this.formLoading = false;
					},
					() => { }
				);
		} catch (error) {
			this.formLoading = false;
			console.log('loadLazy(' + event + ')' + error);
		}
	
	}

	onRowGroupOpened(event) {
		this.columnApi.autoSizeAllColumns();
	}

	fullDateCellRendererUSD(params: any) {
		if (params.data) {
			return moment(params.value).format('MM/DD/YY')
		}
	}

	getPayToName(params: any) {
		if (params?.data) {
			let payToDetails: any = [
				{ value: 0, name: 'Default' },
				{ value: 1, name: 'Guest' },
				{ value: 2, name: 'KBM' },
				{ value: 3, name: 'Homeowner' },
				{ value: 4, name: 'Vendor' },
				{ value: 5, name: 'Travel Agent' },
				{ value: 6, name: 'Rental Car' },
				{ value: 7, name: 'Housekeeping' },
				{ value: 8, name: 'Resort' },
			];
			const status = payToDetails.find((e: any) => e.value == params.value);
			return status.name;
		}
		else {
			return '';
		}
	}

	getPayFromName(params: any) {
		if (params?.data) {
			let payToDetails: any = [
				{ value: 0, name: 'Default' },
				{ value: 1, name: 'Guest' },
				{ value: 2, name: 'KBM' },
				{ value: 3, name: 'Homeowner' },
				{ value: 4, name: 'Vendor' },
				{ value: 5, name: 'Travel Agent' },
				{ value: 6, name: 'Rental Car' },
				{ value: 7, name: 'Housekeeping' },
				{ value: 8, name: 'Resort' },
			];
			const status = payToDetails.find((e: any) => e.value == params.value);
			return status?.name;
		}
		else {
			return '';
		}
	}

	getReservationLedgerTitle(params: any){
		if (params?.data) {
			let orderProductName = params?.data?.orderProductName;
			let isTax = params?.data?.ledgerItemType === 2 || false;
			if(isTax && params?.data?.title){
				return  orderProductName + ':' + params?.data?.title  + ' ('+params?.data?.opsNotes+'%)';
			}
			return orderProductName;
		}
	}

	onSearchSubmit(searchForm: any) {
		this.getReservationsLedger(searchForm);
		console.log(searchForm);
	}

	ngOnInit(): void {
		
		// ag-grid
		this.gridOptions.rowData = this.reservationLedgers;
		this.gridOptions.columnDefs = this.columnDefs;
		this.gridOptions.autoGroupColumnDef = this.autoGroupColumnDef;
		this.gridOptions.pagination = true;
		this.gridOptions.suppressAggFuncInHeader = true;
		this.gridOptions.animateRows = true;
		this.gridOptions.defaultColDef = this.defaultColDef;

		// Footer
		this.gridOptions.groupIncludeFooter = true;
		this.gridOptions.groupIncludeTotalFooter = true;
		this.getReservationsLedger({});

		// https://www.ag-grid.com/javascript-data-grid/column-sizing/
		// this.gridOptions.suppressColumnVirtualisation = true;
	}

	ngAfterViewInit(): void {
		(this.gridOptions as any).api?.setColumnDefs(this.columnDefs);
	}

	onGridReady(grid: any): void {
		this.gridApi = grid;
		this.columnApi = grid.columnApi;

	}
	onFirstDataRendered(params: any): void {
		setTimeout(() => { this.columnApi.autoSizeAllColumns(); }, 5000);
	}

}
